import { render, staticRenderFns } from "./ObjectLink.vue?vue&type=template&id=774c8508&scoped=true&"
import script from "./ObjectLink.vue?vue&type=script&lang=js&"
export * from "./ObjectLink.vue?vue&type=script&lang=js&"
import style0 from "./ObjectLink.vue?vue&type=style&index=0&id=774c8508&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774c8508",
  null
  
)

export default component.exports